<ion-header
    [ngClass]="{
        'title-center': centerTitle,
        'header--blue': type === 'image-gallery',
        'header--with-gallery': type === 'image-gallery' && images.length > 0
    }"
    [style.--ion-toolbar-background]="backgroundColor"
    [style.--ion-toolbar-color]="contentColor"
    [style.--ripple-color]="rippleColor"
    class="ion-no-border header"
    mode="md">
    <ion-toolbar>
        <ion-buttons *ngIf="leftActionButton !== 'none'" [ngClass]="{ 'ion-padding-start': leftPadding }" slot="start">
            @if (leftActionButton === 'close') {
                <lib-close-button [color]="contentColor || 'var(--ion-color-dark)'" (onClick)="onCloseButtonClick()" />
            }

            @if (leftActionButton === 'back-custom') {
                <lib-back-button
                    [style.--button-size]="'40px'"
                    (onClick)="this.backButtonClick.emit()"
                    [arrowIconPath]="backButtonArrowPath"
                    [chevronIconPath]="backButtonChevronPath"
                    [showBorder]="backButtonWithBorder"
                    [color]="contentColor || 'var(--ion-color-dark)'"
                    [backgroundColor]="backgroundColor || 'rgba(255, 255, 255, 0.6)'"
                    [rippleColor]="rippleColor || 'var(--ion-color-dark)'" />
            }

            @if (leftActionButton === 'back-button' || leftActionButton === 'back-button-history') {
                <lib-back-button
                    [style.--button-size]="'40px'"
                    (onClick)="backClick()"
                    [backButtonDefaultHref]="backButtonDefaultHref"
                    [arrowIconPath]="backButtonArrowPath"
                    [chevronIconPath]="backButtonChevronPath"
                    [showBorder]="backButtonWithBorder"
                    [color]="contentColor || 'var(--ion-color-dark)'"
                    [backgroundColor]="backgroundColor || 'rgba(255, 255, 255, 0.6)'"
                    [rippleColor]="rippleColor || 'var(--ion-color-dark)'" />
            }
        </ion-buttons>

        <ion-title class="header-title" color="primary">
            <span [ngClass]="type === 'logo' ? 'sr-only' : null" [style.color]="contentColor" class="text-dark">
                {{ title }}
            </span>
            <div class="header-logo">
                <ion-img *ngIf="type === 'logo'" [alt]="logoAltText" [src]="logoUrl" />
            </div>
            <div *ngIf="type === 'user'" class="header-user full-width flex align-items-center">
                <lib-avatar-image
                    [customSize]="48"
                    [customTextSize]="20"
                    [image]="proUserService.user()?.avatar_url || clientUserService.user()?.photo_url" />
                <div class="header-user-info margin-left-small">
                    <h2 [style.--color]="contentColor" class="ion-no-margin h4">
                        {{ user?.first_name }} {{ user?.last_name }}
                    </h2>
                    <p [style.--color]="contentColor" class="ion-no-margin text-paragraph">
                        {{ today | date: 'EE, dd MMM' }}
                    </p>
                </div>
            </div>
        </ion-title>

        <ion-buttons *ngIf="rightActionButton !== 'none'" [ngClass]="{ 'ion-padding-end': rightPadding }" slot="end">
            @if (showNotificationBellButton) {
                <lib-notification-bell-button *ngIf="rightActionButton === 'notification'" />
            }

            <lib-close-button (onClick)="onCloseButtonClick()" *ngIf="rightActionButton === 'close'" />

            <lib-button
                (onClick)="onSkipButtonClick()"
                *ngIf="rightActionButton === 'skip'"
                [backgroundColor]="backgroundColor || 'rgba(255, 255, 255, 0.6)'"
                [color]="contentColor || 'var(--ion-color-dark)'"
                [rippleColor]="rippleColor || 'var(--ion-color-dark)'"
                borderStyle="none">
                Skip
            </lib-button>

            <lib-favorite-button *ngIf="rightActionButton === 'favorite'" [proId]="proId" />

            <lib-button
                (onClick)="onResetButtonClick()"
                *ngIf="rightActionButton === 'reset'"
                [backgroundColor]="backgroundColor || 'rgba(255, 255, 255, 0.6)'"
                [color]="contentColor || 'var(--ion-color-dark)'"
                [displayAsInlineText]="true"
                [rippleColor]="rippleColor || 'var(--ion-color-dark)'"
                borderStyle="none">
                Reset
            </lib-button>

            <lib-icon-button
                (onClick)="onSettingsButtonClick()"
                *ngIf="rightActionButton === 'settings'"
                [backgroundColor]="'var(--ion-color-dark-0)'"
                [border]="false"
                [color]="'var(--ion-color-dark)'"
                [rippleColor]="rippleColor || 'var(--ion-color-dark)'"
                [style.--button-size]="'40px'"
                display="circle"
                iconName="settings-outline" />

            @if (rightActionButton === 'custom') {
                <ng-container>
                    <ng-content select="header-right"></ng-content>
                </ng-container>
            }
        </ion-buttons>
    </ion-toolbar>
    <ng-content></ng-content>
</ion-header>
<div class="header--gallery">
    <lib-gallery-lightbox
        [images]="images"
        [slidePagination]="true"
        [slideSpaceBetween]="0"
        [slidesPerView]="1"
        additionalClasses="header--gallery"
        thumbnailDisplay="slider" />
</div>
